// import { CookieModule } from 'ngx-cookie';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeRu from '@angular/common/locales/ru';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { NgEventOptionsModule } from 'ng-event-options';

import { RsFormsExtentionFormFieldRegistry } from '@rs-bank/rs-forms-extention';


import { AppVersionModule } from 'ib/internetbank-core/app-version/app-version.module';
import { DevToolsModule } from 'ib/internetbank-core/dev-tools/dev-tools.module';
import { InternetbankFieldsRegisrty } from 'ib/internetbank-fields/internetbank-fields.regisrty';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthorizationModule } from './authorization/authorization.module';
import { AuthorizationService } from './authorization/authorization.service';
import { DeviceInformationService } from './authorization/device-information.service';
import { LoggedInRedirectGuardService } from './authorization/logged-in-redirect-guard.service';
import { CommonAppModule } from './common/common-app.module';
import { CustomValidationModule } from './common/custom-validation/custom-validation.module';
import { HttpInterceptors } from './common/interseptors';
import { CurrencyRatesServiceService } from './common/services/currency-rates-service.service';
import { HttpClientExtension } from './common/services/http-client-extension.service';
import { LoaderService } from './common/services/loader.service';
import { PersonalInformationService } from './common/services/personal-information.service';
import { ResourcesService } from './common/services/resources.service';
import { RouteHistoryService } from './common/services/route-history.service';
import { TransferDataPassService } from './common/services/transfer-data-pass.service';
import { CustomRouteReuseStrategy } from './common/utils/custom-route-reuse.strategy';
import { FavoriteCardService } from './products/common/favorite-card.service';
import { CreditPartialPaymentWizardService } from './products/credits/credit-partial-payment-wizard/credit-partial-payment-wizard.service';
import { CreditPartialPaymentGuard } from './products/credits/credit-partial-payment-wizard/guard/credit-partial-payment-wizard.guard';
import { ProductSuggestionListFacade } from './products/left-panel/product-list/product-suggestion-list/product-suggestion-list.facade';
import { CardOrderListFacade } from './products/left-panel/product-list/request-product-order/card-order-list/card-order-list.facade';
import { CreditOrderListFacade } from './products/left-panel/product-list/request-product-order/credit-order-list/credit-order-list.facade';
import { ProductsRenamingService } from './products/products-renaming.service';
import { ProductsModule } from './products/products.module';
import { ConfigFacadeService } from './sections/config.facade.service';
import { ChargeItemService } from './sections/operations/payments/payment-widgets/shared/charge-item/charge-item.service';
import { SectionsModule } from './sections/sections.module';
import { SplashBannersModule } from './shared/splash-banners/splash-banners.module';
import { TechnicalAlertsModule } from './shared/technical-alerts/technical-alerts.module';
import { TooltipPopupService } from './ui/controls/tooltip-popup/tooltip-popup.service';
import { LayoutModule } from './ui/layout/layout.module';
import { UiModule } from './ui/ui.module';
// импорт должен следовать за UiModule


registerLocaleData(localeRu);

@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		ProductsModule,
		SectionsModule,
		AppRoutingModule,
		CommonAppModule,
		CustomValidationModule,
		UiModule,
		LayoutModule,
		AuthorizationModule,
		DragDropModule,
		DevToolsModule,
		AppVersionModule,
		TechnicalAlertsModule,
		NgEventOptionsModule,
		OverlayModule,
		SplashBannersModule,
	],
	providers: [
		// HttpExtensionService,
		HttpClientExtension,
		RouteHistoryService,
		ProductsRenamingService,
		HttpInterceptors,
		{
			provide: LOCALE_ID,
			useValue: 'ru-RU',
		},
		FavoriteCardService,
		PersonalInformationService,
		// /*AngularJS Services*/ validationServiceProvider, SettingsServiceProvider, /* VirtualKeyboardServiceProvider,*/
		LoaderService,
		AuthorizationService,
		DeviceInformationService,
		LoggedInRedirectGuardService,
		TooltipPopupService,
		ChargeItemService,
		TransferDataPassService,
		CurrencyRatesServiceService,
		ResourcesService,
		{
			provide: RouteReuseStrategy,
			useClass: CustomRouteReuseStrategy,
		},
		{
			provide: RsFormsExtentionFormFieldRegistry,
			useClass: InternetbankFieldsRegisrty,
		},
		// https://github.com/angular/angular/issues/10280
		// { provide: UrlSerializer, useClass: CustomUrlSerializer },
		ProductSuggestionListFacade,
		CardOrderListFacade,
		CreditOrderListFacade,
		CreditPartialPaymentWizardService,
		CreditPartialPaymentGuard,
		ConfigFacadeService,
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AppModule { }
